const isMobile = () => window.innerWidth <= 1025;

export { isMobile };
